(() => {
  const currentSrc = document.currentScript?.src || '';
  if (currentSrc) {
    const coreSrc = currentSrc.replace(/card-republic-enhancements\.js(?:\?.*)?$/, 'card-republic-enhancements-core.js');
    if (coreSrc && coreSrc !== currentSrc) {
      const coreScript = document.createElement('script');
      coreScript.src = coreSrc;
      coreScript.async = false;
      coreScript.dataset.crCore = '1';
      document.head.appendChild(coreScript);
    }
  }

  const STORAGE_KEY = 'cardRepublicTheme';
  const THEMES = ['gold', 'electric', 'crimson', 'abyss', 'rose', 'ultraviolet'];

  const copy = {
    sk: {
      trigger: 'Vzhľad',
      title: 'Vyber si vzhľad Card Republic',
      subtitle: 'Výber sa uloží v tomto prehliadači.',
      gold: ['Republic Gold', 'Čierna + zlatá'],
      electric: ['Electric Pulse', 'Modrá + elektrická žltá'],
      crimson: ['Crimson Eclipse', 'Bordová + červená'],
      abyss: ['Abyss Teal', 'Čierna + tmavá tyrkysová'],
      rose: ['Rose Noir', 'Čierna + ružová'],
      ultraviolet: ['Ultraviolet', 'Čierna + fialová'],
      applied: 'Vzhľad bol zmenený'
    },
    en: {
      trigger: 'Theme',
      title: 'Choose your Card Republic theme',
      subtitle: 'Your choice is saved in this browser.',
      gold: ['Republic Gold', 'Black + gold'],
      electric: ['Electric Pulse', 'Blue + electric yellow'],
      crimson: ['Crimson Eclipse', 'Burgundy + red'],
      abyss: ['Abyss Teal', 'Black + dark turquoise'],
      rose: ['Rose Noir', 'Black + pink'],
      ultraviolet: ['Ultraviolet', 'Black + purple'],
      applied: 'Theme changed'
    }
  };

  const getLang = () => (document.documentElement.lang || 'sk').toLowerCase().startsWith('sk') ? 'sk' : 'en';

  function readTheme() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return THEMES.includes(saved) ? saved : 'gold';
    } catch (_) {
      return 'gold';
    }
  }

  function saveTheme(theme) {
    try { localStorage.setItem(STORAGE_KEY, theme); } catch (_) {}
  }

  function setTheme(theme, announce = false) {
    const safe = THEMES.includes(theme) ? theme : 'gold';
    document.documentElement.dataset.crTheme = safe;
    saveTheme(safe);

    document.querySelectorAll('[data-cr-pick]').forEach((button) => {
      const active = button.dataset.crPick === safe;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (announce) {
      const status = document.querySelector('.cr-theme-switcher__status');
      if (status) status.textContent = copy[getLang()].applied;
    }
  }

  setTheme(readTheme());

  const css = `
html[data-cr-theme="gold"] {
  --cr-bg-rgb: 11,11,15; --cr-surface-rgb: 21,20,26; --cr-surface2-rgb: 31,29,24;
  --cr-text-rgb: 247,241,223; --cr-muted-rgb: 191,183,160;
  --cr-accent-rgb: 212,175,55; --cr-accent2-rgb: 245,215,123; --cr-button-text-rgb: 16,14,8;
  --cr-page-bg: radial-gradient(circle at 14% 8%,rgba(212,175,55,.18),transparent 32%),radial-gradient(circle at 90% 18%,rgba(126,88,17,.14),transparent 36%),linear-gradient(135deg,#070709 0%,#0d0d11 46%,#17130a 100%);
  --cr-card-bg: linear-gradient(145deg,rgba(28,27,32,.96),rgba(13,13,17,.94));
  --cr-header-bg: rgba(10,10,13,.86); --cr-border: rgba(212,175,55,.34); --cr-glow: rgba(212,175,55,.24);
  --cr-hero-overlay: linear-gradient(90deg,rgba(4,4,6,.91) 0%,rgba(12,10,5,.64) 45%,rgba(212,175,55,.07) 100%);
}
html[data-cr-theme="electric"] {
  --cr-bg-rgb: 5,16,30; --cr-surface-rgb: 8,31,51; --cr-surface2-rgb: 11,43,68;
  --cr-text-rgb: 241,249,255; --cr-muted-rgb: 155,190,215;
  --cr-accent-rgb: 255,216,39; --cr-accent2-rgb: 56,189,248; --cr-button-text-rgb: 9,20,32;
  --cr-page-bg: radial-gradient(circle at 82% 10%,rgba(56,189,248,.22),transparent 32%),radial-gradient(circle at 16% 18%,rgba(255,216,39,.13),transparent 26%),linear-gradient(135deg,#03101f 0%,#06213a 53%,#05131f 100%);
  --cr-card-bg: linear-gradient(145deg,rgba(8,38,61,.96),rgba(4,17,29,.95));
  --cr-header-bg: rgba(3,16,29,.88); --cr-border: rgba(56,189,248,.35); --cr-glow: rgba(56,189,248,.26);
  --cr-hero-overlay: linear-gradient(90deg,rgba(2,11,21,.93) 0%,rgba(4,30,49,.62) 48%,rgba(255,216,39,.08) 100%);
}
html[data-cr-theme="crimson"] {
  --cr-bg-rgb: 18,7,11; --cr-surface-rgb: 32,13,19; --cr-surface2-rgb: 48,16,25;
  --cr-text-rgb: 255,240,243; --cr-muted-rgb: 210,164,173;
  --cr-accent-rgb: 230,57,90; --cr-accent2-rgb: 255,179,107; --cr-button-text-rgb: 255,248,247;
  --cr-page-bg: radial-gradient(circle at 82% 10%,rgba(230,57,90,.22),transparent 33%),radial-gradient(circle at 14% 82%,rgba(255,179,107,.11),transparent 34%),linear-gradient(135deg,#0c0407 0%,#1b080f 49%,#270b13 100%);
  --cr-card-bg: linear-gradient(145deg,rgba(45,15,24,.96),rgba(17,6,10,.95));
  --cr-header-bg: rgba(18,7,11,.9); --cr-border: rgba(230,57,90,.36); --cr-glow: rgba(230,57,90,.26);
  --cr-hero-overlay: linear-gradient(90deg,rgba(11,3,7,.93) 0%,rgba(39,8,18,.64) 48%,rgba(230,57,90,.08) 100%);
}
html[data-cr-theme="abyss"] {
  --cr-bg-rgb: 3,8,8; --cr-surface-rgb: 7,18,18; --cr-surface2-rgb: 11,29,28;
  --cr-text-rgb: 239,253,251; --cr-muted-rgb: 142,170,167;
  --cr-accent-rgb: 15,169,162; --cr-accent2-rgb: 85,230,220; --cr-button-text-rgb: 3,20,19;
  --cr-page-bg: radial-gradient(circle at 82% 10%,rgba(15,169,162,.24),transparent 33%),radial-gradient(circle at 14% 78%,rgba(85,230,220,.08),transparent 34%),linear-gradient(135deg,#020606 0%,#061312 50%,#081d1b 100%);
  --cr-card-bg: linear-gradient(145deg,rgba(8,31,29,.96),rgba(3,11,11,.96));
  --cr-header-bg: rgba(2,8,8,.91); --cr-border: rgba(15,169,162,.36); --cr-glow: rgba(15,169,162,.27);
  --cr-hero-overlay: linear-gradient(90deg,rgba(1,7,7,.94) 0%,rgba(5,31,29,.64) 48%,rgba(85,230,220,.07) 100%);
}
html[data-cr-theme="rose"] {
  --cr-bg-rgb: 8,4,7; --cr-surface-rgb: 20,10,17; --cr-surface2-rgb: 33,16,28;
  --cr-text-rgb: 255,245,250; --cr-muted-rgb: 196,154,175;
  --cr-accent-rgb: 226,56,135; --cr-accent2-rgb: 255,130,189; --cr-button-text-rgb: 26,5,15;
  --cr-page-bg: radial-gradient(circle at 82% 10%,rgba(226,56,135,.23),transparent 33%),radial-gradient(circle at 13% 80%,rgba(255,130,189,.08),transparent 34%),linear-gradient(135deg,#060305 0%,#140811 50%,#210c19 100%);
  --cr-card-bg: linear-gradient(145deg,rgba(37,13,29,.96),rgba(12,5,10,.96));
  --cr-header-bg: rgba(8,4,7,.91); --cr-border: rgba(226,56,135,.36); --cr-glow: rgba(226,56,135,.27);
  --cr-hero-overlay: linear-gradient(90deg,rgba(7,2,5,.94) 0%,rgba(41,9,27,.64) 48%,rgba(255,130,189,.07) 100%);
}
html[data-cr-theme="ultraviolet"] {
  --cr-bg-rgb: 6,4,9; --cr-surface-rgb: 16,11,24; --cr-surface2-rgb: 27,18,40;
  --cr-text-rgb: 251,247,255; --cr-muted-rgb: 173,157,189;
  --cr-accent-rgb: 134,87,242; --cr-accent2-rgb: 202,140,255; --cr-button-text-rgb: 16,6,29;
  --cr-page-bg: radial-gradient(circle at 82% 10%,rgba(134,87,242,.24),transparent 33%),radial-gradient(circle at 15% 78%,rgba(202,140,255,.09),transparent 34%),linear-gradient(135deg,#040306 0%,#0f0918 50%,#1b0f2c 100%);
  --cr-card-bg: linear-gradient(145deg,rgba(29,18,45,.96),rgba(9,6,14,.96));
  --cr-header-bg: rgba(6,4,9,.91); --cr-border: rgba(134,87,242,.37); --cr-glow: rgba(134,87,242,.28);
  --cr-hero-overlay: linear-gradient(90deg,rgba(4,2,7,.94) 0%,rgba(28,13,48,.64) 48%,rgba(202,140,255,.07) 100%);
}

html[data-cr-theme] body,
html[data-cr-theme] body.gradient {
  background: var(--cr-page-bg) !important;
  background-attachment: fixed !important;
  color: rgb(var(--cr-text-rgb)) !important;
}
html[data-cr-theme] body,
html[data-cr-theme] .gradient,
html[data-cr-theme] [class*="color-"] {
  --color-background: var(--cr-bg-rgb) !important;
  --color-foreground: var(--cr-text-rgb) !important;
  --color-button: var(--cr-accent-rgb) !important;
  --color-button-text: var(--cr-button-text-rgb) !important;
  --color-secondary-button: var(--cr-surface-rgb) !important;
  --color-secondary-button-text: var(--cr-text-rgb) !important;
  --color-link: var(--cr-accent-rgb) !important;
  --color-shadow: 0,0,0 !important;
  --gradient-background: linear-gradient(145deg,rgba(var(--cr-surface-rgb),.96),rgba(var(--cr-bg-rgb),.96)) !important;
}
html[data-cr-theme] .header-wrapper,
html[data-cr-theme] .shopify-section-group-header-group,
html[data-cr-theme] sticky-header {
  background: var(--cr-header-bg) !important;
  backdrop-filter: blur(18px) saturate(130%);
  -webkit-backdrop-filter: blur(18px) saturate(130%);
}
html[data-cr-theme] .header-wrapper { border-bottom: 1px solid var(--cr-border) !important; box-shadow: 0 12px 36px rgba(0,0,0,.22); }
html[data-cr-theme] .footer,
html[data-cr-theme] .shopify-section-group-footer-group { border-top-color: var(--cr-border) !important; }
html[data-cr-theme] .card-wrapper .card,
html[data-cr-theme] .product-card-wrapper .card,
html[data-cr-theme] .collection-list .card {
  background: var(--cr-card-bg) !important;
  border: 1px solid var(--cr-border) !important;
  border-radius: 16px !important;
  box-shadow: 0 14px 38px rgba(0,0,0,.22);
  transition: transform .24s ease, border-color .24s ease, box-shadow .24s ease;
  overflow: hidden;
}
html[data-cr-theme] .card-wrapper:hover .card,
html[data-cr-theme] .product-card-wrapper:hover .card {
  transform: translateY(-3px);
  border-color: rgba(var(--cr-accent-rgb),.7) !important;
  box-shadow: 0 16px 46px var(--cr-glow);
}
html[data-cr-theme] .card__heading a,
html[data-cr-theme] .product__title,
html[data-cr-theme] h1, html[data-cr-theme] h2, html[data-cr-theme] h3 { color: rgb(var(--cr-text-rgb)) !important; }
html[data-cr-theme] .price,
html[data-cr-theme] .price-item,
html[data-cr-theme] .product__info-container .price { color: rgb(var(--cr-accent2-rgb)) !important; }
html[data-cr-theme] .button:not(.cr-theme-switcher__trigger):not(.cr-theme-option),
html[data-cr-theme] .quick-add__submit,
html[data-cr-theme] button.shopify-payment-button__button--unbranded {
  background: rgb(var(--cr-accent-rgb)) !important;
  color: rgb(var(--cr-button-text-rgb)) !important;
  border-color: rgb(var(--cr-accent-rgb)) !important;
  box-shadow: 0 8px 24px var(--cr-glow) !important;
}
html[data-cr-theme] .button:not(.cr-theme-switcher__trigger):not(.cr-theme-option):hover,
html[data-cr-theme] .quick-add__submit:hover { filter: brightness(1.07); transform: translateY(-1px); }
html[data-cr-theme] .field__input,
html[data-cr-theme] .select__select,
html[data-cr-theme] .customer .field input,
html[data-cr-theme] .quantity,
html[data-cr-theme] .search__input {
  background: rgba(var(--cr-surface-rgb),.82) !important;
  color: rgb(var(--cr-text-rgb)) !important;
  border-color: var(--cr-border) !important;
}
html[data-cr-theme] .badge { border-color: rgba(var(--cr-accent-rgb),.55) !important; }
html[data-cr-theme] .cr-hero { border: 1px solid var(--cr-border); box-shadow: 0 22px 60px rgba(0,0,0,.34),0 0 38px var(--cr-glow); }
html[data-cr-theme] .cr-hero__overlay { background: var(--cr-hero-overlay) !important; }
html[data-cr-theme] .cr-hero__button { background: rgb(var(--cr-accent-rgb)) !important; color: rgb(var(--cr-button-text-rgb)) !important; box-shadow: 0 10px 30px var(--cr-glow) !important; }
html[data-cr-theme] .cr-product-explorer,
html[data-cr-theme] .cr-daily-collector,
html[data-cr-theme] .cr-hub,
html[data-cr-theme] .cr-september-draw,
html[data-cr-theme] .cr-draw { --cr-gold: rgb(var(--cr-accent-rgb)); --cr-accent: rgb(var(--cr-accent-rgb)); }

.cr-theme-switcher { position: relative; display: inline-flex; align-items: center; margin-right: .5rem; z-index: 90; }
.cr-theme-switcher__trigger {
  min-height: 4rem; display: inline-flex; align-items: center; gap: .7rem; padding: 0 1.25rem;
  border: 1px solid var(--cr-border); border-radius: 999px; background: rgba(var(--cr-surface-rgb),.88);
  color: rgb(var(--cr-text-rgb)); font: inherit; font-size: 1.3rem; font-weight: 700; letter-spacing: .03em;
  cursor: pointer; box-shadow: 0 8px 24px rgba(0,0,0,.18); transition: .2s ease;
}
.cr-theme-switcher__trigger:hover { border-color: rgba(var(--cr-accent-rgb),.78); box-shadow: 0 8px 28px var(--cr-glow); }
.cr-theme-switcher__palette { font-size: 1.7rem; line-height: 1; }
.cr-theme-switcher__chev { width: 8px; height: 8px; border-right: 2px solid currentColor; border-bottom: 2px solid currentColor; transform: rotate(45deg) translateY(-2px); opacity: .7; transition: transform .2s ease; }
.cr-theme-switcher.is-open .cr-theme-switcher__chev { transform: rotate(225deg) translate(-2px,-2px); }
.cr-theme-switcher__panel {
  position: absolute; top: calc(100% + 12px); right: 0; width: min(430px,calc(100vw - 24px)); padding: 18px;
  border: 1px solid var(--cr-border); border-radius: 18px; background: rgba(var(--cr-surface-rgb),.97);
  color: rgb(var(--cr-text-rgb)); box-shadow: 0 22px 70px rgba(0,0,0,.42),0 0 28px var(--cr-glow);
  backdrop-filter: blur(22px) saturate(140%); -webkit-backdrop-filter: blur(22px) saturate(140%);
  opacity: 0; visibility: hidden; transform: translateY(-8px) scale(.985); transform-origin: top right;
  transition: opacity .18s ease,transform .18s ease,visibility .18s ease; pointer-events: none;
}
.cr-theme-switcher.is-open .cr-theme-switcher__panel { opacity: 1; visibility: visible; transform: none; pointer-events: auto; }
.cr-theme-switcher__head { margin-bottom: 13px; }
.cr-theme-switcher__head strong { display: block; font-size: 1.45rem; line-height: 1.25; }
.cr-theme-switcher__head span { display: block; margin-top: 4px; color: rgba(var(--cr-text-rgb),.66); font-size: 1.15rem; line-height: 1.35; }
.cr-theme-switcher__grid { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 9px; }
.cr-theme-option {
  position: relative; min-width: 0; display: grid; grid-template-columns: 42px 1fr; gap: 10px; align-items: center;
  padding: 10px; border: 1px solid rgba(var(--cr-text-rgb),.14); border-radius: 13px; background: rgba(var(--cr-bg-rgb),.46);
  color: rgb(var(--cr-text-rgb)); text-align: left; cursor: pointer; transition: .18s ease;
}
.cr-theme-option:hover { border-color: rgba(var(--cr-accent-rgb),.58); transform: translateY(-1px); }
.cr-theme-option.is-active { border-color: rgb(var(--cr-accent-rgb)); box-shadow: inset 0 0 0 1px rgba(var(--cr-accent-rgb),.28),0 8px 22px var(--cr-glow); }
.cr-theme-option.is-active::after { content: '✓'; position: absolute; top: 7px; right: 8px; width: 18px; height: 18px; display: grid; place-items: center; border-radius: 50%; background: rgb(var(--cr-accent-rgb)); color: rgb(var(--cr-button-text-rgb)); font-size: 11px; font-weight: 900; }
.cr-theme-option__swatch { width: 42px; height: 42px; border-radius: 11px; box-shadow: inset 0 0 0 1px rgba(255,255,255,.14),0 5px 14px rgba(0,0,0,.28); }
.cr-theme-option[data-cr-pick="gold"] .cr-theme-option__swatch { background: radial-gradient(circle at 70% 25%,#f5d77b,transparent 29%),linear-gradient(135deg,#09090b 0 58%,#d4af37 59%); }
.cr-theme-option[data-cr-pick="electric"] .cr-theme-option__swatch { background: radial-gradient(circle at 70% 24%,#ffd827,transparent 28%),linear-gradient(135deg,#061426 0 54%,#38bdf8 55%); }
.cr-theme-option[data-cr-pick="crimson"] .cr-theme-option__swatch { background: radial-gradient(circle at 70% 24%,#ffb36b,transparent 28%),linear-gradient(135deg,#18070d 0 55%,#e6395a 56%); }
.cr-theme-option[data-cr-pick="abyss"] .cr-theme-option__swatch { background: radial-gradient(circle at 70% 24%,#55e6dc,transparent 28%),linear-gradient(135deg,#020707 0 56%,#0fa9a2 57%); }
.cr-theme-option[data-cr-pick="rose"] .cr-theme-option__swatch { background: radial-gradient(circle at 70% 24%,#ff82bd,transparent 28%),linear-gradient(135deg,#080407 0 56%,#e23887 57%); }
.cr-theme-option[data-cr-pick="ultraviolet"] .cr-theme-option__swatch { background: radial-gradient(circle at 70% 24%,#ca8cff,transparent 28%),linear-gradient(135deg,#060409 0 56%,#8657f2 57%); }
.cr-theme-option__copy { min-width: 0; padding-right: 14px; }
.cr-theme-option__copy strong { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 1.15rem; }
.cr-theme-option__copy span { display: block; margin-top: 2px; color: rgba(var(--cr-text-rgb),.62); font-size: 1rem; line-height: 1.25; }
.cr-theme-switcher__status { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
.cr-theme-switcher--floating { position: fixed; top: 92px; right: 18px; z-index: 999; }
@media (max-width: 989px) {
  .cr-theme-switcher__trigger { width: 4rem; padding: 0; justify-content: center; }
  .cr-theme-switcher__label,.cr-theme-switcher__chev { display: none; }
  .cr-theme-switcher__panel { position: fixed; top: 76px; right: 12px; }
}
@media (max-width: 440px) {
  .cr-theme-switcher__panel { width: calc(100vw - 20px); right: 10px; padding: 14px; }
  .cr-theme-switcher__grid { grid-template-columns: 1fr; }
}
@media (prefers-reduced-motion: reduce) {
  .cr-theme-switcher *, html[data-cr-theme] .card { transition: none !important; }
}
`;

  if (!document.getElementById('cr-theme-skins-css')) {
    const style = document.createElement('style');
    style.id = 'cr-theme-skins-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function buildSwitcher() {
    if (document.querySelector('.cr-theme-switcher')) return;

    const lang = getLang();
    const t = copy[lang];
    const root = document.createElement('div');
    root.className = 'cr-theme-switcher';
    root.innerHTML = `
      <button class="cr-theme-switcher__trigger" type="button" aria-expanded="false" aria-haspopup="dialog" title="${t.trigger}">
        <span class="cr-theme-switcher__palette" aria-hidden="true">◈</span>
        <span class="cr-theme-switcher__label">${t.trigger}</span>
        <span class="cr-theme-switcher__chev" aria-hidden="true"></span>
      </button>
      <div class="cr-theme-switcher__panel" role="dialog" aria-label="${t.title}" aria-hidden="true">
        <div class="cr-theme-switcher__head"><strong>${t.title}</strong><span>${t.subtitle}</span></div>
        <div class="cr-theme-switcher__grid">
          ${THEMES.map((theme) => `<button type="button" class="cr-theme-option" data-cr-pick="${theme}" aria-pressed="false"><span class="cr-theme-option__swatch" aria-hidden="true"></span><span class="cr-theme-option__copy"><strong>${t[theme][0]}</strong><span>${t[theme][1]}</span></span></button>`).join('')}
        </div>
      </div>
      <span class="cr-theme-switcher__status" aria-live="polite"></span>`;

    const trigger = root.querySelector('.cr-theme-switcher__trigger');
    const panel = root.querySelector('.cr-theme-switcher__panel');
    const close = () => {
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
    };
    const toggle = () => {
      const open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    };

    trigger.addEventListener('click', (event) => { event.stopPropagation(); toggle(); });
    root.querySelectorAll('[data-cr-pick]').forEach((button) => {
      button.addEventListener('click', () => { setTheme(button.dataset.crPick, true); close(); trigger.focus(); });
    });
    document.addEventListener('click', (event) => { if (!root.contains(event.target)) close(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });

    const icons = document.querySelector('.header__icons');
    if (icons) {
      const cart = icons.querySelector('.header__icon--cart, a[href*="/cart"]');
      icons.insertBefore(root, cart || null);
    } else {
      root.classList.add('cr-theme-switcher--floating');
      document.body.appendChild(root);
    }

    setTheme(readTheme());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildSwitcher, { once: true });
  else buildSwitcher();

  document.addEventListener('shopify:section:load', () => {
    if (!document.querySelector('.cr-theme-switcher')) buildSwitcher();
  });
})();
